export default {
  removeVipCode() {
    return new Promise((resolve, reject) => {
      axios.delete(`/web/api/checkouts/vip-code`)
        .then((success) => {
          resolve(success.data.total)
        }).catch((error) => {
          reject(error)
        })
    })
  }
}
